import { render, staticRenderFns } from "./aShopDetailInstock.vue?vue&type=template&id=09af5bb6&scoped=true"
import script from "./aShopDetailInstock.vue?vue&type=script&lang=js"
export * from "./aShopDetailInstock.vue?vue&type=script&lang=js"
import style0 from "./aShopDetailInstock.vue?vue&type=style&index=0&id=09af5bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09af5bb6",
  null
  
)

export default component.exports